import { createContext, useContext } from 'react';

export const UserContext = createContext({ rol: 'colaborador', estudioId: null, estudios: [], cambiarEstudio: () => {} });

export function useRol() { return useContext(UserContext).rol; }
export function useEsAdmin() { return useContext(UserContext).rol === 'admin'; }
export function useEstudioId() { return useContext(UserContext).estudioId; }
export function useEstudios() { return useContext(UserContext).estudios; }
export function useCambiarEstudio() { return useContext(UserContext).cambiarEstudio; }
